var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AbstractDownloadTask from './abstract-download-task';
import Exception from '../exception/exception';
export default class AbstractRestDownloadTask extends AbstractDownloadTask {
    execute() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.downloadFile();
            // Handle failed responses
            if (response.status !== 200) {
                // Throw a TokenExpired exception if this is the failure
                const isTokenExpired = yield this.isTokenExpired(response);
                if (this.authenticated && isTokenExpired) {
                    throw new Error(Exception.TokenExpired);
                }
                else {
                    throw new Error(Exception.UnknownError);
                }
            }
            const filename = this.generateFilename(response);
            yield this.streamFileToClient(response, filename);
        });
    }
    /**
     * Returns the base url
     */
    get baseUrl() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return window.API_BASE_URL;
    }
    /**
     * Returns whether the token has expired
     *
     * @param response
     */
    isTokenExpired(response) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield response.json();
            return (response.status === 401 && data.message === 'Expired JWT Token');
        });
    }
}
//# sourceMappingURL=abstract-rest-download-task.js.map